import Text from "../../assets/icon/NewsIcons/MainAdmin/NewsText"
import { MainAdminTablesContactUs} from "../../components"
import React, { useState, useEffect } from "react";
import Cookies from 'universal-cookie';
import { axiosReq } from "../../commons/axiosReq";
import { useNavigate } from "react-router-dom";

const MainAdminContactUs = () => {

        const titleRow = [ "نام", "ایمیل", "عنوان"];
            const example = ["رشد ارز چه آثاری بر روی قیمت خودرو دارد؟", "طلا و ارز", "1403/04/16", "علیرضا بابایی"];
        
            const [showEditModal, setShowEditModal] = React.useState(false);
            const [showDeleteModal, setShowDeleteModal] = React.useState(false);
            const [data, setData] = useState();
            const [contextData, setContextData] = useState();
            const [search, setSearch] = useState("");
            const [reCheck, setRecheck] = useState(false);
            const [count, setCount] = useState();
            const [page, setPage] = useState(1);
            const [row, setRow] = useState(10);
     
                 const [snipper, setSnipper] = useState(false);
             
            const [allValues, setAllValues] = useState({
                Mobile: contextData ? contextData.mobile : '',
                Email: data ? data.email : '',
                PhoneNumber: data ? data.phoneNumber : '',
                Address: data ? data.adress : '',
        
        
            });
            const [allValuesError, setAllValuesError] = useState({
                Mobile: false,
                Email: false,
                PhoneNumber: false,
                Address: false,
        
            });
            const GetData = async () => {
   
                const contexData = await axiosReq("Admins/GetContext" , "get");
                console.log(999)
                console.log(contexData)
setContextData(contexData)
setAllValues({
    Mobile: contexData ? contexData[0].mobile : '',
    Email: contexData ? contexData[0].email : '',
    PhoneNumber: contexData ? contexData[0].phoneNumber : '',
    Address: contexData ? contexData[0].address : '',
})
                const writersData = await axiosReq("Admins/GetContacts?page=" + page + "&&pageSize=" + row + "&&search=" + search , "get");
                console.log(writersData)
                setData(writersData?.data)
                setCount(writersData?.count)
        
            }
           
            useEffect(() => {
        
                GetData();
            }, [reCheck, search, page, row]);
        
            const allFull = (obj) => {
                const updatedState = {};
                var result = true;
                for (var o in obj) {
                    if (obj[o] == "") {
                        updatedState[o] = true;
        
        
                        setAllValuesError({ ...allValuesError, ...updatedState })
                        result = false;
                    }
                    // else if(obj[o] == "" && o=="SubCategoryId" && obj["CategoryId"] != ""){
                    //     updatedState[o] = true;
        
        
                    //     setAllValuesError({ ...allValuesError, ...updatedState })
                    //     result = false;
                    // }
        
                }
                console.log(allValuesError)
                return result
            }
            const changeHandler = e => {
                if (e.target) {
                    if (e.target.value != "") {
        
                        setAllValuesError({ ...allValuesError, [e.target.name]: false })
                    }
                    else {
                        setAllValuesError({ ...allValuesError, [e.target.name]: true })
        
                    }
                    // setAllValuesError({ ...allValuesError, [""]: false })
        
        
                    setAllValues({ ...allValues, [e.target.name]: e.target.value })
                }
            }

              const updateAdmin = async () => {
            
                    setSnipper(true)
            
            
              
            
                    var res = allFull(allValues)
                    console.log(res)
                    if (res) {
                        const dataUser = await axiosReq("Admins/UpdateContext", "put", {
                            contextId:1,
                            Mobile:allValues.Mobile,
                            Email: allValues.Email,
                            PhoneNumber: allValues.PhoneNumber,
                            Address: allValues.Address,
            
                        });
                        console.log(dataUser)
                        if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                            setRecheck(!reCheck)
                            // setShowModal(false)
                            //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
                            alert("موفقیت آمیز");
            
                        }
                        else {
                            console.log(allValuesError)
                            // setEroor(dataUser?.data)
                            alert(dataUser?.data);
                        }
                    }
                    else {
                   
            
                        console.log(allValuesError)
            
                    }
                }
    return(
        <div >
            <div className="flex items-center border-b-2 border-borderGray p-[20px]">
                <div className="flex items-center">
                <div><Text /></div>
                <p className="font-IRANYekanExtra text-[15px] text-mainColor2 mr-[15px]"> صفحه تماس با ما</p>
                </div>
            </div>
            <div className="pt-[25px] pb-[200px] px-[20px]">
                <div className="border-b-4 flex flex-col items-center border-borderGray pb-[20px]">
                    <div className="flex w-[98%] justify-start items-end pb-4 ">
            <div className="w-[100%]">
            <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-[10px]">پست الکترونیک</p>
            <input   
            value={allValues?.Email}
            name="Email"   
            onChange={changeHandler}
            className="h-[35px]  w-full focus:outline-lightGray border-[2px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="پست الکترونیک را بنویسید (در صورت وجود چند مورد با علامت , موارد را جدا کنید)" />
            </div>
            
            
                    </div>
                    <div className="flex w-[98%] justify-start items-end pb-4 ">
            <div className="w-[100%]">
            <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-[10px]">شماره تماس</p>
            <input   
            value={allValues?.PhoneNumber}
            name="PhoneNumber"   
            onChange={changeHandler}
            className="h-[35px]  w-full focus:outline-lightGray border-[2px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="شماره تماس را بنویسید (در صورت وجود چند مورد با علامت , موارد را جدا کنید)" />
            </div>
            
            
                    </div>
                    <div className="flex w-[98%] justify-start items-end pb-4 ">
            <div className="w-[100%] ">
            <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-[10px]">تلفن همراه</p>
            <input   
            value={allValues?.Mobile}
            name="Mobile"   
            onChange={changeHandler}
            className="h-[35px]  w-full focus:outline-lightGray border-[2px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder="تلفن همراه را بنویسید (در صورت وجود چند مورد با علامت , موارد را جدا کنید)" />
            </div>
            
            
                    </div>
                    <div className="flex w-[98%] justify-start items-end pb-4 ">
            <div className="w-[100%] ">
            <p className="text-[15px] font-IRANYekanExtra text-mainColor2 mb-[10px]">آدرس</p>
            <textarea
            type="text"
            maxLength={200}  
            value={allValues?.Address}
            name="Address"   
            onChange={changeHandler}
            className="h-[70px]  w-full focus:outline-lightGray border-[2px] border-borderGray text-[12px] font-IRANYekanNormal px-[10px] py-[10px] rounded-[5px] placeholder-lightGray"
            placeholder="آدرس را بنویسید" />
            </div>
            
            
                    </div>
                    <div className="w-[120px] ">
            <button 
            onClick={()=>updateAdmin()} 
            className="w-full h-[40px] bg-Orange2 shadow-norm-shadow rounded-[10px] flex justify-center items-center ">
                <p className="font-IRANYekanBold text-[15px] text-white">ثبت</p>
            </button>
            </div>
                </div>
                <div>
                
                <div className="pt-[20px] px-[20px] pb-[280px]">
                <p className="font-IRANYekanExtra mb-3 mt-5 text-[16px] text-mainColor2 mr-[15px]">لیست پیام ها :</p>
                <MainAdminTablesContactUs 
                    setShowBlockModal={null} setShowDeleteModal={setShowDeleteModal}
                    setShowEditModal={null}
                    titleRow={titleRow}  
                    data={data} setRecheck={setRecheck} reCheck={reCheck}
                    count={count} page={page} setPage={setPage} 
                    row={row} setRow={setRow} />
            </div>
                </div>
            </div>
               
        </div>
    )
}

export default MainAdminContactUs;